import { selectOrganisationInfos } from '@/domain/organisation/organisation.selectors';
import { selectCurrentProjectTour } from '@/domain/project-tour/project-tour.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { TourSequence } from '../entities/project-tour-ontour-sequence.entity';
import { getTourSequences } from './get-tour-sequences.action';

type Params = Pick<TourSequence, 'name'>;

type Result = void;

export const addTourSequence = createAppAsyncThunk(
  'projectTourOntour/addTourSequence',
  async (
    params: Params,
    {
      extra: { projectTourOntourGateway, snackbarGateway },
      dispatch,
      getState,
    },
  ): Promise<Result> => {
    try {
      const projectId = selectCurrentProjectTour(getState())?.id || -1;
      const organisationId = selectOrganisationInfos(getState()).id;
      await projectTourOntourGateway.addSequence(
        organisationId,
        projectId,
        params.name,
      );
      await dispatch(getTourSequences());
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('AddTourSequence.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('AddTourSequence.Message.error'));
}
